import React from 'react';

import cx from 'classnames';
import { Link } from 'react-router-dom';

import styles from './iconWithTitle.module.scss';

interface Props {
  icon?: React.ReactNode;
  title?: string;
  isActive?: boolean;
  url: string;
  target?: string;
}

const IconWithTitle: React.FC<Props> = (props) => {
  const { icon, title, isActive, url, target } = props;

  return (
    <Link
      target={target}
      className={cx(styles.IconWithTitle, { [styles.active]: isActive })}
      to={url}
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.titleWrapper}>
        <p className={styles.title}>{title}</p>
      </div>
    </Link>
  );
};

export default IconWithTitle;
